import { Box, Heading, Stack, Text, VStack } from "@biblioteksentralen/react";
import { useSitePalette } from "../../utils/useSitePalette";
import { WorkCoversFan } from "../../components/lists/CoversFan";
import { getDotseparated } from "./getDotseparated";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { TruncatedList } from "./TruncatedList";
import { SubjectLinks } from "./SubjectLinks";
import { TypeTag } from "./DocumentTypes";
import {
  CollectionMetaData,
  WorksSortedByNumberInSeries,
} from "../../app/[locale]/sites/[siteDomain]/samling/serie/[seriesId]/utils";

type Props = { worksSortedByNumberInSeries: WorksSortedByNumberInSeries; collectionMetadata: CollectionMetaData };

const CollectionViewBanner = ({ worksSortedByNumberInSeries, collectionMetadata }: Props) => {
  const { t, ts } = useTranslation();
  const palette = useSitePalette();

  const { collectionTitle, sortedGenresAndAgeGroups, sortedSubjects, sortedMainContributorAgents } = collectionMetadata;

  return (
    <Box
      width="100%"
      padding={{ base: "1rem", sm: "2rem", lg: "3rem" }}
      margin="0 auto"
      borderRadius="2xl"
      position="relative"
      {...palette.colors.card.css}
    >
      <Stack direction={{ base: "column", sm: "row" }} gap={{ base: "1rem", md: "2rem" }}>
        <WorkCoversFan
          works={worksSortedByNumberInSeries.numberedWorks.concat(worksSortedByNumberInSeries.nonNumberedWorks)}
          width="15rem"
          minWidth="10rem"
          borderRadius="0.5rem"
          alignSelf="center"
        />
        <VStack alignItems="flex-start" gap="0">
          <VStack alignItems="flex-start" gap="0.5rem">
            <TypeTag styleColors={palette.colors.pop1} fontSize="xs">
              {t("Serie")}
            </TypeTag>
            <Text lineHeight="1.2">
              {getDotseparated(sortedGenresAndAgeGroups.slice(0, 3).map(({ name }) => ts(name)))}
            </Text>
            <Heading as={"h2"} size="lg">
              {collectionTitle ?? t("Serie")}
            </Heading>
          </VStack>

          <VStack alignItems="flex-start" gap="0.5rem">
            <TruncatedList
              items={sortedMainContributorAgents}
              max={2}
              label={
                sortedMainContributorAgents[0]?.type === "Person"
                  ? ts(sortedMainContributorAgents[0].fieldOfActivity)
                  : t("Forfatter")
              }
              fontSize="xl"
              textDecoration="underline"
              _hover={{ textDecoration: "none !important" }}
              marginBottom="0.5rem"
            />
            {sortedSubjects.length > 0 && (
              <SubjectLinks subjects={sortedSubjects.slice(0, 3)} paletteColor={palette.colors.darkaccent4} />
            )}
          </VStack>
        </VStack>
      </Stack>
    </Box>
  );
};

export default CollectionViewBanner;
